"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xhr = xhr;
function xhr(url, params) {
    let method = params.method || 'GET';
    let isBinary = params.isBinary;
    let progressCallback = params.progressCallback;
    if (!url) {
        throw new Error('Url parameter missing');
    }
    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();
        if (isBinary) {
            request.responseType = 'arraybuffer';
        }
        if (isBinary && progressCallback) {
            request.addEventListener('progress', event => {
                if (event.lengthComputable) {
                    progressCallback(request, event.loaded / event.total);
                }
                else {
                    let totalStr = request.getResponseHeader('content-length');
                    let total = 0;
                    if (totalStr) {
                        total = parseFloat(totalStr);
                    }
                    let encoding = request.getResponseHeader('content-encoding');
                    if (total && encoding && encoding.indexOf('gzip') > -1) {
                        total *= 4;
                        let loadedPercent = Math.min(0.99, event.loaded / total);
                        progressCallback(request, loadedPercent);
                    }
                    else {
                        progressCallback(request, 0);
                    }
                }
            });
        }
        request.addEventListener('readystatechange', (event) => {
            if (event.target.readyState !== 4) {
                return;
            }
            if (event.target.status === 200) {
                if (progressCallback) {
                    progressCallback(request, 1);
                }
                resolve(event.target.response);
            }
            else {
                reject({
                    status: event.target.status
                });
            }
        });
        request.open(method, url, true);
        request.send();
    });
}
